import { v4 as uuidV4 } from 'uuid';
import { CellClassParams, ColDef } from '@ag-grid-community/core';

import { TableItem } from './types';

export const TABLE_COL_IDS = {
    MANUFACTURER: 'manufacturer',
    EXTENDED_COST: 'extendedCost',
    EXTENDED_DISCOUNTED_COST: 'extendedDiscountCost',
    MARGIN: 'margin',
    EXTENDED_REVENUE: 'extendedRevenue',
    EXTENDED_PRICE: 'extendedPrice',
    LOT_ID: 'lotId',
    BLANK_COL: 'blank_space_column'
} as const;

export const defaultColDef: ColDef<TableItem> = {
    flex: 1,
    resizable: true,
    suppressFillHandle: true,
    suppressMenu: true,
    sortable: false,
    unSortIcon: true,
    wrapHeaderText: true,
    editable: false,
    cellClassRules: {
        'ag-grid-disable-cell': () => true
    }
};

export const STYLE_CONTSANTS = {
    LINE_HEIGHT: 20,
    P_BLOCK: 8
} as const;

export const commonCellStyle = {
    lineHeight: `${STYLE_CONTSANTS.LINE_HEIGHT}px`,
    paddingBlock: `${STYLE_CONTSANTS.P_BLOCK}px`
};

const pricingCellStyle = {
    ...commonCellStyle,
    display: 'flex',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'flex-end'
};

export const LEVEL = {
    AGG_FOOTER: -1,
    NORMAL: 0
} as const;

export const AGG_FOOTER_ROW_ID = uuidV4();

export const getCenteredCellStyle = (params: CellClassParams<TableItem>) => {
    return params.node.data?.id === AGG_FOOTER_ROW_ID ? { ...pricingCellStyle, fontWeight: 600 } : pricingCellStyle;
};
